import { FormattedMessage } from 'react-intl'
import Typography from '@mui/material/Typography'
import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import { useTeam } from '../../../contexts/TeamContext'
import { useNodes } from '../../../contexts/NodesContext'
import { useProjects } from '../../../contexts/ProjectsContext'
import LoadingState from '../../../shared/components/LoadingState'
import ErrorState from '../../../shared/components/ErrorState'
import Page from '../../../shared/components/layouts/Page'
import PageHeader from '../../../shared/components/layouts/PageHeader'
import PageBody from '../../../shared/components/layouts/PageBody'
import Grid from '@mui/material/Grid'
import FlexColumn from '../../../shared/components/layouts/FlexColumn'
import DashboardNodeCard from './components/DashboardNodeCard'
import DashboardProjectCard from './components/DashboardProjectCard'
import DashboardIngressList from './components/DashboardIngressList'

function TeamDashboardPage() {
  const { team, loading: teamLoading, error: teamError } = useTeam()
  const { nodes, loading: nodesLoading } = useNodes()
  const { projects, loading: projectsLoading } = useProjects()

  if (teamLoading) return <LoadingState />
  if (teamError) return <ErrorState messageId="teams.error" />

  const isLoading = nodesLoading || projectsLoading

  return (
    <Page>
      <PageHeader
        title={<FormattedMessage id="dashboard.title" />}
        entities={{ team }}
      />
      <PageBody>
        {isLoading ? (
          <LoadingState />
        ) : (
          <FlexColumn gap={4}>
            <FlexColumn gap={2} alignItems="stretch">
              <Typography variant="h6">
                <FormattedMessage id="dashboard.nodes.title" />
              </Typography>
              {isEmpty(nodes) ? (
                <Typography color="text.secondary">
                  <FormattedMessage id="dashboard.nodes.empty" />
                </Typography>
              ) : (
                <Grid container spacing={2}>
                  {map(nodes, (node) => (
                    <Grid size={3} key={node.id}>
                      <DashboardNodeCard node={node} />
                    </Grid>
                  ))}
                </Grid>
              )}
            </FlexColumn>

            <FlexColumn gap={2} alignItems="stretch">
              <Typography variant="h6">
                <FormattedMessage id="dashboard.projects.title" />
              </Typography>
              {isEmpty(projects) ? (
                <Typography color="text.secondary">
                  <FormattedMessage id="dashboard.projects.empty" />
                </Typography>
              ) : (
                <Grid container spacing={2}>
                  {map(projects, (project) => (
                    <Grid size={3} key={project.id}>
                      <DashboardProjectCard project={project} />
                    </Grid>
                  ))}
                </Grid>
              )}
            </FlexColumn>

            <FlexColumn gap={2}>
              <Typography variant="h6">
                <FormattedMessage id="dashboard.quickNav.title" />
              </Typography>
              <DashboardIngressList />
            </FlexColumn>
          </FlexColumn>
        )}
      </PageBody>
    </Page>
  )
}

export default TeamDashboardPage
